import axiosInstance from './service'

// === Categories ===
const getDocumentCategories = async () => {
  const res = await axiosInstance.get('/documents/categories')
  return res
}

const createDocumentCategory = async (name) => {
  const res = await axiosInstance.post('/documents/categories', { name })
  return res
}

const updateDocumentCategory = async (id, name) => {
  const res = await axiosInstance.put(`/documents/categories/${id}`, { name })
  return res
}

const deleteDocumentCategory = async (id) => {
  const res = await axiosInstance.delete(`/documents/categories/${id}`)
  return res
}

const reorderDocumentCategories = async (categories) => {
  const res = await axiosInstance.put('/documents/categories/reorder', { categories })
  return res
}

// === Documents ===
const getDocumentsByCategory = async (categoryId) => {
  const res = await axiosInstance.get(`/documents/categories/${categoryId}/documents`)
  return res
}

const uploadDocument = async (formData) => {
  const res = await axiosInstance.post('/documents/documents', formData)
  return res
}

const createLink = async (data) => {
  const res = await axiosInstance.post('/documents/links', data)
  return res
}

const updateDocument = async (id, data) => {
  const res = await axiosInstance.put(`/documents/documents/${id}`, data)
  return res
}

const deleteDocument = async (id) => {
  const res = await axiosInstance.delete(`/documents/documents/${id}`)
  return res
}

const reorderDocuments = async (documents) => {
  const res = await axiosInstance.put('/documents/documents/reorder', { documents })
  return res
}

export {
  getDocumentCategories,
  createDocumentCategory,
  updateDocumentCategory,
  deleteDocumentCategory,
  reorderDocumentCategories,
  getDocumentsByCategory,
  uploadDocument,
  createLink,
  updateDocument,
  deleteDocument,
  reorderDocuments
}
